import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ShieldCheck } from 'lucide-react';
import { companyInfo } from '../data';

export default function Footer() {
  return (
    <footer className="bg-white text-zinc-600">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-4 py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-14 md:h-20 object-contain"
              />
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h3 className="text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Hurtige Links
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-red-600 transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/service" className="hover:text-red-600 transition-colors">Serviceydelser</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-red-600 transition-colors">Om os</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-red-600 transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Kontakt Os
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="h-5 w-5 text-zinc-900 shrink-0 mt-0.5" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="h-5 w-5 text-zinc-900 shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-red-600 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="h-5 w-5 text-zinc-900 shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-red-600 transition-colors break-all">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours Column */}
          <div>
            <h3 className="text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Åbningstider
            </h3>
            <ul className="space-y-2 text-sm">
              {companyInfo.openingHours.map((item, index) => (
                <li key={index} className="flex flex-col border-b border-zinc-100 pb-1.5 last:border-0">
                  <span className="font-medium text-zinc-700">{item.days}</span>
                  <span className="text-xs text-zinc-400 flex items-center gap-1 mt-0.5">
                    <Clock className="h-3 w-3 text-zinc-900" />
                    {item.hours}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="bg-white border-t border-zinc-200 py-6 text-center text-xs text-zinc-500">
        <div className="mx-auto max-w-7xl px-4 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {new Date().getFullYear()} {companyInfo.name}. CVR: {companyInfo.cvr}. Alle rettigheder forbeholdes.</p>
          <p className="text-zinc-400">Udviklet med fokus på driftssikkerhed</p>
        </div>
      </div>
    </footer>
  );
}
